import styled from 'styled-components';

const ArrowStyle = styled.div`
	width: 0;
	height: 0;

	.wrapper {
		transform-origin: 50% 50%;
		display: flex;
	}

	.arrow-inner-all-wrap {
		width: fit-content;
		height: fit-content;
		display: flex;
	}

	@keyframes swing {
		0% {
			transform: rotate(${(props) => props.$diapason[0]});
		}
		50% {
			transform: rotate(${(props) => props.$diapason[1]});
		}
		100% {
			transform: rotate(${(props) => props.$diapason[0]});
		}
	}

	.swing {
		animation: swing ease-in-out infinite;
		animation-duration: ${(props) => props.$speed};
	}
`;
export default ArrowStyle;
